import { Modal } from 'react-bootstrap';
import { ReactComponent as Warning } from '../../Assets/img/Warning.svg';
import { ReactComponent as TickBlue } from '../../Assets/img/TickBlue.svg';
import { ReactComponent as CloseWhite } from '../../Assets/img/CloseWhite.svg';

function WarningMessagePopup(props) {
    return (
        <Modal centered={true} size={props.largeModal == null ? "medium":"lg"} contentClassName="message-popup-container" show={true} onHide={props.onClose}>
            <Modal.Header className="message-popup-container-header" closeButton><Warning />
                <Modal.Title className="message-popup-title">{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.body}
            </Modal.Body>
            <Modal.Footer className="message-popup-container-footer">
                <button type="submit" className="primary-button message-popup-no-button" onClick={props.onClose}>
                    <span className="primary-button-icon"><CloseWhite className="message-popup-close-white-icon" ></CloseWhite></span>
                    <span className="primary-button-text">No</span>
                </button>
                <button type="submit" className="secondary-button" onClick={props.onAction}>
                    <span className="secondary-button-icon"><TickBlue /></span>
                    <span className="secondary-button-text">Yes</span>
                </button>                
            </Modal.Footer>
        </Modal>
    );
}

export default WarningMessagePopup;